import ViewControls from '@/client/components/ViewControls/organisms/ViewControls';

export default ViewControls;
